import { render, staticRenderFns } from "./SoFormBackdoor.vue?vue&type=template&id=6f1237e9&"
import script from "./SoFormBackdoor.vue?vue&type=script&lang=js&"
export * from "./SoFormBackdoor.vue?vue&type=script&lang=js&"
import style0 from "./SoFormBackdoor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports